export const useContentApi = () => ({
  getList(type, lang) {
    return useApi().makeRequest(
      `/contents/${type}`,
      'get',
      null,
      { params: lang ? { lang } : undefined },
      false,
      true
    )
  },
  getOne(type, slug, lang) {
    return useApi().makeRequest(
      `/contents/${type}/${slug}`,
      'get',
      null,
      { params: lang ? { lang } : undefined },
      false,
      true
    )
  },
})
